export default [
	"50 YEARS OF GUARANTEE For Joint Leakage.",
    "CFTRI Certified For Food And Drinking Water Transportation.",
    "Withstandable Upto 140°C Temperature And 25kg Pressure.",
    "Free Transportation Upto The Worksite.",
]